<style lang="scss" scoped>
    .icon {
        border-radius: 50%;
        width: 4px;
        height: 4px;
    }
</style>
<template>
    <div>
        <tj-title-bar :title="healthcheckBookTeam.teamName+'每日预约情况'"></tj-title-bar>
        <div class="bg_fff radius3 mt15">
            <section class="flex pl15 pr15 pt10 pb10 aic">
                <p class="fs14 flex1">
                    <el-button size="mini" @click="$router.back()">返回</el-button>
                    分配号源：<span class="color_main">{{total.bookedNumberSourceTotal||total.waitCheckCount||0}}</span>个
                    剩余号源：<span class="color_red">{{total.numberSourceTotal-total.bookedNumberSourceTotal||total.surplusNumberSourceTotal}}</span>个
                </p>
                <!--<p class="flex0">
                    <el-button size="mini" @click="handler">今天</el-button>
                    <el-button size="mini" icon="el-icon-arrow-left" @click="handler('-')"></el-button>
                    <el-button size="mini" icon="el-icon-arrow-right" @click="handler('+')"></el-button>
                    <span class="fs14 ml10">{{currText}}</span>
                </p>-->
            </section>
            <el-table :data="list" size="mini" border style="width: 100%">
                <el-table-column label="序号" prop="sortNumber"></el-table-column>
                <el-table-column label="时段">
                    <template slot-scope="{row}">
                        <span>{{row.timeIntervalStartTime}}~{{row.timeIntervalEndTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="预约状态">
                    <template slot-scope="{row}">
                        <div class="flex aic">
                            <span class="icon mr5" :class="[getIconColor(row.bookedStatus)]"></span>
                            <span>{{row.bookedStatus?'已预约':'未预约'}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="预约人（病案号）">
                    <template slot-scope="{row}">
                        <span v-if="row.bookedStatus">{{row.healthcheckerName}}({{row.healthcheckMedicalRecord}})</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="{row}">
                        <el-button v-if="!row.bookedStatus" type="text" size="mini" @click="sub(row)">预约
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <dialog-tj-yuyue ref="yuyue" @error="showError" @ok="getData"></dialog-tj-yuyue>
        <dialog-error ref="error"></dialog-error>
    </div>
</template>
<script>
  import TjTitleBar from "../components/tj-title-bar";
  import dayjs from 'dayjs';
  import {healthcheckService} from "../services/healthcheck";
  import {riliItemCacheKey} from "../config";
  import {filter_get_order_status} from "../filter";
  import DialogTjYuyue from "../components/dialog-tj-yuyue";
  import {timeFormat} from "../../../common/lib/utils";
  import DialogError from "../components/dialog-error";

  export default {
    name: 'tj-list',
    filters: {filter_get_order_status},
    components: {DialogError, DialogTjYuyue, TjTitleBar},
    data() {
      return {
        curr: new Date(),
        total: {},
        list: []
      }
    },
    computed: {
      currText() {
        return dayjs(this.curr).format('YYYY月MM年DD日');
      }
    },
    created() {
      const {date} = this.$route.query;
      if (date) this.curr = dayjs(date);
      this.total = this.$cache.get(riliItemCacheKey);
      this.getData();
    },
    methods: {
      async getData() {
        const date = dayjs(this.curr).format('YYYY-MM-DD');
        //this.list = await healthcheckService.tjhyDate(date);
        this.list = await healthcheckService.tjhyDateAll({
          date, bookedTeamId: this.healthcheckBookTeam.id
        });
      },
      getIconColor(status) {
        if (!status) return 'bg_red';
        return 'bg_main';
      },
      sub(data) {
        const {curr} = this;
        this.$refs.yuyue.open({
          ...data,
          week: timeFormat(dayjs(curr).valueOf(), '%W'),
          date: dayjs(curr).format('YYYY-MM-DD')
        })
      },
      showError(data, list) {
        this.$refs.error.open(data, list);
      },
      handler(type) {
        const {curr} = this;
        if (type === '+') this.curr = dayjs(curr).add(1, 'day');
        else if (type === '-') this.curr = dayjs(curr).subtract(1, "day");
        else this.curr = new Date();
        this.getData();
      }
    },
  }
</script>
